import React from 'react';
import PropTypes from 'prop-types';
import Label from '../shared/Label';
import { HeaderTableWrapper } from './styles';

const HeaderTable = ({ title, bgColor }) =>
  (
    <HeaderTableWrapper
      bgColor={bgColor}
    >
      <Label
        label={title}
        size={1.2}
        margin="0 0 0 0.55em"
        color="mainFontColor"
        isTitleNarrowMedium
      />
    </HeaderTableWrapper>
  );

HeaderTable.propTypes = {
  title: PropTypes.string,
  bgColor: PropTypes.string,
};

export default HeaderTable;
